import { ModalTypes, ModalActionTypes } from './index';

export function setModalIsOpened(
  open: boolean,
  name: string | null
): ModalActionTypes {
  return {
    type: ModalTypes.SET_MODAL_IS_OPENED,
    payload: { open, name }
  };
}
